module.exports = __webpack_public_path__ + "media/images/pen_peachpuff-ebbbd6e1.png";